<div class="flex flex-grow">
  <div class="flex-grow">
    <label [class.disabled]="disabled" [class.checked]="checked" (click)="!disabled ? toggleChecked(): null">
      <input disabled [checked]="checked" type="checkbox" />
      <div class="checkbox-img" [class.radio-img]="radio">
        @if(checked){
          <i class="fa-thin fa-check checkmark checkmark-wrapper"></i>
        }
      </div>
      @if (icon) {
        <div class="checkbox-icon" ><img [src]="icon" [class.isPrecious]="isPrecious" /></div>
      }
      @if (label) {
        <div [innerHTML]="label"></div>
      }
      <ng-content></ng-content>
    </label>
  </div>
  @if (hasInfo) {
    <i class="fa-light fa-circle-info" (click)="toggleInfo()"></i>
  }
</div>
@if (showInfo) {
  <div class="checkbox-info-content" [@fadeInOutTransition]>
    <ng-content select="[info-content]"></ng-content>
  </div>
}